import { createContext, useContext } from 'react'
import { FilesCollection } from '@/stores/useFiles.ts'
import { InfiniteQueryObserverResult } from '@tanstack/react-query'

export interface DriveViewFilesContextValue {
  currentFilesCollection: FilesCollection | null
  hasNextPage?: boolean
  fetchNextPage: () => Promise<InfiniteQueryObserverResult>
  isLoading: boolean
}

export const DriveViewFilesContext = createContext<DriveViewFilesContextValue | null>(null)

export function useDriveViewFilesContext() {
  return useContext(DriveViewFilesContext)
}
